'use client';

import { useEffect, useRef } from 'react';

const MEDIA_PAUSE_REQUEST = 'mediapauserequest';

export const useMediaPauseRequest = <T extends HTMLElement>(
  onPause?: () => void,
) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || !onPause) return;

    element.addEventListener(MEDIA_PAUSE_REQUEST, onPause);
    return () => element.removeEventListener(MEDIA_PAUSE_REQUEST, onPause);
  }, [onPause]);

  return ref;
};
